import React, { Component } from 'react'
import { Flex } from 'hljd'
import { Button } from 'hljd'
import { hashHistory } from 'react-router'
import { EXPERIENCE_SHOP_BILL_PATH } from '@constant'
import MoneyItem from '../MoneyItem'
import { observer, inject } from 'mobx-react'
import { getMoney } from '@hlj/hlj-utils'

@inject('pageStore')
@observer
export default class extends Component {
  render() {
    const { brokerageInfo } = this.props.pageStore
    const { currentMonthOrderCount, currentMonthBrokerageMoney } = brokerageInfo

    return (
      <>
        <Flex
          style={{
            flex: 1,
            backgroundColor: '#fff',
            padding: '30px 30px 30px 20px'
          }}
          sp
          vc
        >
          <Flex>
            <MoneyItem
              title="本月完成合作订单"
              value={currentMonthOrderCount}
              style={{ marginRight: 40 }}
            />

            <MoneyItem
              title="本月已支付服务费"
              value={getMoney(currentMonthBrokerageMoney)}
            />
          </Flex>

          <Button
            onClick={() => {
              hashHistory.push(EXPERIENCE_SHOP_BILL_PATH)
            }}
          >
            查看对账单
          </Button>
        </Flex>
      </>
    )
  }
}
